import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { PuppyCard } from "../components/PuppyCard";
import { getPuppies } from "../lib/api";

const EMAIL = "teacuppuppies4sale@gmail.com";

export default function Shop() {
  const [puppies, setPuppies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPuppies("available")
      .then(setPuppies)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="shop-page">
      <PageHero
        eyebrow="Available Now"
        title={["Choose your", "forever companion."]}
        subtitle="Each of our puppies is hand-raised, fully vetted, and ready to be adored. Select a little one to view details and reserve securely."
      />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-10">
        {loading ? (
          <p className="text-[#8a7a68]">Loading puppies…</p>
        ) : puppies.length === 0 ? (
          <p className="text-[#8a7a68]" data-testid="no-puppies">
            All our puppies have found homes. Check back soon or visit our upcoming litters.
          </p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {puppies.map((p, i) => (
              <PuppyCard key={p.id} puppy={p} index={i} />
            ))}
          </div>
        )}

        <div className="mt-16 text-center border-t border-[#E2D1C3] pt-14">
          <p className="text-[#5c5245] font-light text-lg mb-6">
            Have a question about a puppy or want to reserve one? We&apos;d love to hear from you.
          </p>
          <a
            href={`mailto:${EMAIL}?subject=Puppy%20Inquiry`}
            data-testid="shop-contact-email-btn"
            className="inline-flex items-center gap-2 bg-[#2A2118] text-[#FDFBF7] px-9 py-4 rounded-sm text-sm tracking-wide hover:bg-[#3d3226] transition-colors"
          >
            <Mail size={16} /> Contact Us
          </a>
        </div>
      </section>
    </div>
  );
}
